import { FC, ReactNode } from 'react';

import classNames from 'classnames';

const allowedRatios = {
   '1:1': 'aspect-[1/1]',
   '4:3': 'aspect-[4/3]',
   '3:2': 'aspect-[3/2]',
   '16:9': 'aspect-[16/9]',
   '21:9': 'aspect-[21/9]',
   '32:9': 'aspect-[32/9]'
};

const phoneRatios = {
   '1:1': 'phone:aspect-[1/1]',
   '4:3': 'phone:aspect-[4/3]',
   '3:2': 'phone:aspect-[3/2]',
   '16:9': 'phone:aspect-[16/9]',
   '21:9': 'phone:aspect-[21/9]',
   '32:9': 'phone:aspect-[32/9]'
};

const tabletRatios = {
   '1:1': 'tab-land:aspect-[1/1] tab-port:aspect-[1/1]',
   '4:3': 'tab-land:aspect-[4/3]  tab-port:aspect-[4/3]',
   '3:2': 'tab-land:aspect-[3/2]  tab-port:aspect-[3/2]',
   '16:9': 'tab-land:aspect-[16/9]  tab-port:aspect-[16/9]',
   '21:9': 'tab-land:aspect-[21/9]  tab-port:aspect-[21/9]',
   '32:9': 'tab-land:aspect-[32/9]  tab-port:aspect-[32/9]'
};

const desktopRatios = {
   '1:1': 'desktop:aspect-[1/1]',
   '4:3': 'desktop:aspect-[4/3]',
   '3:2': 'desktop:aspect-[3/2]',
   '16:9': 'desktop:aspect-[16/9]',
   '21:9': 'desktop:aspect-[21/9]',
   '32:9': 'desktop:aspect-[32/9]'
};

type AspectRatio = keyof typeof allowedRatios;

interface Props {
   height?: string;
   width?: string;
   phone?: AspectRatio;
   tablet?: AspectRatio;
   desktop?: AspectRatio;
   aspectRatio?: AspectRatio;
   useContainerQuery?: boolean;
   children: ReactNode;
}

export const AspectRatio: FC<Props> = ({ phone, tablet, desktop, aspectRatio, useContainerQuery = false, height, width, children }) => {
   const className = classNames('flex justify-center overflow-hidden', aspectRatio && allowedRatios[aspectRatio], phone && phoneRatios[phone], tablet && tabletRatios[tablet], desktop && desktopRatios[desktop]);

   return (
      <div className={className} style={{ height, width }}>
         {children}
      </div>
   );
};
